// @flow
import { useMemo } from 'react';

import useShouldIncludeInactiveTeams from 'common/hooks/useShouldIncludeInactiveTeams';
import { TeamStatusEnum } from 'common/enums/TeamEnum';
import type { TeamModelType } from 'common/models/flow/Team';
import { Team } from 'common/models/internal/Team';

const useFilteredTeams = (
    teams: Array<Team | TeamModelType> = [],
    shouldConsiderInactiveTeamsToggle: boolean = false
): Array<Team | TeamModelType> => {
    const [shouldIncludeInactiveTeams] = useShouldIncludeInactiveTeams();

    const relevantTeams = useMemo(() => {
        // shouldConsiderInactiveTeamsToggle controls if we need to handle presence of inactive teams toggle
        // shouldIncludeInactiveTeams controls whether or not the toggle is active
        // teams is expected to be the list of all teams
        if (shouldConsiderInactiveTeamsToggle && shouldIncludeInactiveTeams) {
            return teams;
        }
        return teams.filter(team => team.status !== TeamStatusEnum.Inactive);
    }, [teams, shouldIncludeInactiveTeams, shouldConsiderInactiveTeamsToggle]);

    return relevantTeams;
};

export default useFilteredTeams;
